let API_KEY = process.env.REACT_APP_SHOPIFY_API_KEY || '';
let API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
let PRODUCTION_MODE = process.env.REACT_APP_PRODUCTION || true;
export default {
    API_KEY: API_KEY,
    API_URL: API_URL,
    PRODUCTION_MODE: PRODUCTION_MODE === "true" || PRODUCTION_MODE === true
};
